import type { PropsWithChildren } from 'react'

import archiveIcon from 'assets/image/icons/svg/linkedin-icon.svg'
import snail from 'assets/image/snail-looking-for.png'
import clsx from 'clsx'
import { CONSTS } from 'config/objectConst'
import { ui as ContactsUI } from 'features/contacts'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import css from './style.module.scss'

const ContactCards = ({ children }: PropsWithChildren) => (
	<div className={css.root}>
		<main className={css.card}>
			<h2 className={clsx(css.title, typo.subtitle)}>{children}</h2>
			<img alt='snail' className={css.img} src={snail} width={150} />
			<span className={clsx(css.lead, typo.buttonSm)}>
				Select exported or search new on LinkedIn
			</span>

			<div className={css.buttons}>
				<Button
					className={css.button}
					onClick={ContactsUI.AddModal.open}
					type='button'
					typography={typo.largeButton}
					variant='bordered-dark'
				>
					Select exported
				</Button>

				<Button
					as='a'
					className={css.button}
					href={CONSTS.LINKEDIN_URL}
					rel='noopener noreferrer'
					target='_blank'
					typography={typo.largeButton}
				>
					Search on{' '}
					<img
						alt='linkedin icon'
						className={css.icon}
						height={18}
						src={archiveIcon}
						width={18}
					/>
				</Button>
			</div>
		</main>
	</div>
)

export const AddToLaunch = () => (
	<ContactCards>
		Add contacts to launch <br /> your campaign!
	</ContactCards>
)
export const Add = () => (
	<ContactCards>
		Add contacts to your <br /> campaign!
	</ContactCards>
)
